import { Dialog, Transition } from "@headlessui/react";
import React, { useState, Fragment, useRef } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { QrReader } from "react-qr-reader";
import CloseIcon from "@mui/icons-material/Close";

// import { Container } from './styles';

function PopUpCamera({ setQrData, cancelar, back }) {
  const cancelButtonRef = useRef(null);
  const { t } = useTranslation();

  return (
    <Transition.Root show as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={() => back()}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                  
                    type="button"
                    className="inline-flex w-full justify-center rounded-[8px] text-gray-500 px-1 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                    onClick={() => {
                      back();
                      //   setShowForm(false);
                      //   setOpen(false);
                    }}
                  >
                    <CloseIcon />
                  </button>
                </div>
                <div className="bg-white px-4   sm:p-6 p-4">
                  <QrReader
                    onResult={(result, error) => {
                      if (!!result) {
                        setQrData(result?.text);
                        back();
                      }

                      if (!!error) {
                        console.info(error);
                      }
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default PopUpCamera;
